export default __webpack_public_path__ + "staticlp1/media/credit-card-visa.98b6c803.png";